import type { DatePickerProps } from 'react-datepicker';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import './style.scss';

const DatePicker = ({ className, ...props }: DatePickerProps) => {
  return (
    <div className={className}>
      <ReactDatePicker
        showPopperArrow={false}
        showYearDropdown
        dropdownMode="select"
        {...props}
      />
    </div>
  );
};

export { DatePicker };
